export default "__VITE_ASSET__C8br1FSe__"